import { clsx } from 'clsx';
import { DollarIcon } from '../icons/react/dollar.tsx';
import {
  priceTagV2,
  priceTagV2Amount,
  priceTagV2Suffix,
} from './price-tag-v2.css.ts';

export type PriceTagV2Price =
  | 'free'
  | 'inPackage'
  | { per: 'month'; amount: string }
  | { per: 'targets'; amount: string; targets: number };

type PlainPrice = Extract<PriceTagV2Price, string>;
type PaidPrice = Exclude<PriceTagV2Price, PlainPrice>;

const plainPriceCopy = (price: PlainPrice): string => {
  switch (price) {
    case 'free':
      return 'Free';
    case 'inPackage':
      return 'In package';
    default: {
      const exhaustive: never = price;
      return exhaustive;
    }
  }
};

const priceSuffix = (price: PaidPrice): string => {
  switch (price.per) {
    case 'month':
      return '/mo';
    case 'targets':
      return `/${price.targets} targets`;
    default: {
      const exhaustive: never = price;
      return exhaustive;
    }
  }
};

export const PriceTagV2 = ({
  price,
  className,
}: {
  price: PriceTagV2Price;
  className?: string;
}) => {
  if (typeof price === 'string') {
    return (
      <span className={clsx(priceTagV2, className)} data-testid="price-tag-v2">
        {plainPriceCopy(price)}
      </span>
    );
  }

  return (
    <span className={clsx(priceTagV2, className)} data-testid="price-tag-v2">
      <DollarIcon />
      <span className={priceTagV2Amount}>
        <span>{price.amount}</span>
        <span className={priceTagV2Suffix}>{priceSuffix(price)}</span>
      </span>
    </span>
  );
};
